import { render } from "./common-bet-bottom.vue?vue&type=template&id=0fd3a733"
import script from "./common-bet-bottom.vue?vue&type=script&lang=js"
export * from "./common-bet-bottom.vue?vue&type=script&lang=js"

import exportComponent from "F:\\workspan\\java\\lot\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__